import { render } from "./admin-ad-list.vue?vue&type=template&id=3fb78f80"
import script from "./admin-ad-list.vue?vue&type=script&lang=js"
export * from "./admin-ad-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__